import { DEFAULT_WORKSPACE_ID } from '$logic/workspace'

export function getAppbarHeight(
  expanded: boolean,
  selectionMode: boolean,
  workspaceId: string,
) {
  const currentWorkspaceIdIsCommon = workspaceId === DEFAULT_WORKSPACE_ID

  return currentWorkspaceIdIsCommon || selectionMode ? 56 : expanded ? 216 : 56
}
